import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../elements/Header';
import Footer from '../elements/Footer';

const Default = () => {
  return (
    <React.Fragment>
      <div className="techtop-qc-inner-page pt-2">
        <Header />
        <Outlet />
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Default;
